import { isChildNode } from '../lib/helper';

export default class Dropdown {

  constructor(el) {
    if (!el) {
      return;
    }

    this.el = el;
    this.trigger = this.el.querySelector ? this.el.querySelector('.tc-dropdown-trigger') : undefined;
    this.content = this.el.querySelector ? this.el.querySelector('.dropdown-wrapper') : undefined;
    this.onDocumentClickHandler = this.onDocumentClick.bind && this.onDocumentClick.bind(this);
    this.isOpen = false;
    this.el.classList.remove('is-open');
    this.isDisabled = this.el.classList.contains('is-disabled');
    this.checkFocusinsideHandler = this.checkFocusinside.bind && this.checkFocusinside.bind(this);

    document.addEventListener('focusin', this.checkFocusinside.bind && this.checkFocusinside.bind(this), false);
  }

  open() {

    // prevent opening dropdown if the element is set to disabled
    if (this.el.classList.contains('is-disabled')) {

      return;
    }

    this.el.classList.add('is-open');

    document.addEventListener('mousedown', this.onDocumentClickHandler, false);
    this.isOpen = true;
  }

  close() {

    this.el.classList.remove('is-open');

    document.removeEventListener('mousedown', this.onDocumentClickHandler, false);
    this.isOpen = false;
  }

  toggle() {

    if (this.isDisabled) {

      return;
    }

    if (this.isOpen) {

      this.close();
    } else {

      this.open();
    }
  }

  onDocumentClick(e) {

    if (!isChildNode(e.target, this.el)) {

      this.close();
    }
  }

  checkFocusinside(e) {

    // console.log(e.target)

    if (e.target === this.el) {

      if (this.isOpen) {

        return;
      }

      this.open();
      return;
    }

    if (!isChildNode(e.target, this.el)) {

      if (!this.isOpen) {

        return;
      }

      this.close();
      return;
    } else {

      if (this.isOpen) {

        return;
      }

      this.open();
      return;
    }
  }
};
